import React from "react"
import { SVGProps } from "react";

const Drop3 = (props: SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 81 80" {...props}>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M80.166 40C80.166 62.0914 62.2574 80 40.166 80C18.0746 80 0.166016 62.0914 0.166016 40C0.166016 17.9086 18.0746 0 40.166 0C62.2574 0 80.166 17.9086 80.166 40ZM25.5832 40C25.5832 31.9203 32.0863 25.4171 40.166 25.4171C48.2457 25.4171 54.7489 32.1174 54.7489 40.1971V54.5829H40.166C32.0863 54.5829 25.5832 48.0797 25.5832 40Z" fill="currentColor" />
    </svg>
);

export default Drop3;
